const BASE = process.env.REACT_APP_API || "";

export function authHeaders() {
  const token = localStorage.getItem("cs_token");
  return token ? { "Authorization": `Bearer ${token}` } : {};
}

export const api = {
  async getSignals(chain = "ALL") {
    const r = await fetch(`${BASE}/api/signals?chain=${chain}`, { headers: authHeaders() });
    return r.ok ? r.json() : [];
  },
  async getSignal(id) {
    const r = await fetch(`${BASE}/api/signals/${id}`, { headers: authHeaders() });
    return r.ok ? r.json() : null;
  },
  async getHistory(days = 30) {
    const r = await fetch(`${BASE}/api/history?days=${days}`, { headers: authHeaders() });
    return r.ok ? r.json() : [];
  },
  async triggerScan() {
    return fetch(`${BASE}/api/scan/trigger`, { method: "POST", headers: authHeaders() });
  },
  async getPositions() {
    const r = await fetch(`${BASE}/api/positions`, { headers: authHeaders() });
    return r.ok ? r.json() : [];
  },
  async getWallet() {
    const r = await fetch(`${BASE}/api/wallet`, { headers: authHeaders() });
    return r.ok ? r.json() : {};
  },
};
